// src/pages/payment/PaymentCancelPage.jsx
import { AlertCircle } from "lucide-react";
import { useNavigate } from "react-router";

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-[#E5E7EB] p-8 text-center">
        <AlertCircle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
        <h2 className="text-xl text-[#2D323A] mb-2">Payment cancelled</h2>
        <p className="text-sm text-[#717182] mb-6">
          You cancelled the payment. No charge was made.
        </p>
        <div className="flex gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex-1 py-3 border border-[#E5E7EB] rounded-xl text-[#2D323A]"
          >
            Go back
          </button>
          <button
            onClick={() => navigate("/auth/subscription")}
            className="flex-1 py-3 bg-[#1E6DFF] text-white rounded-xl"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
}